import { useParentPageContext } from '@/creditflowresearch/application/ParentPageContext';
import CorporateTopIssuersContextProvider
  from '@/creditflowresearch/application/TopCompanies/corporateTopCompanies/CorporateTopIssuersContext';
import CorporateTopRatingAgencyContextProvider
  from '@/creditflowresearch/application/TopCompanies/corporateTopCompanies/CorporateTopRatingAgenciesContext';
import CorporateTopUnderwritersContextProvider
  from '@/creditflowresearch/application/TopCompanies/corporateTopCompanies/CorporateTopUnderwritersContext';
import TopCompaniesCommon from '@/creditflowresearch/ui/components/TopCompanies/TopCompaniesCommon';
import TopCompanyCommonCorporateContextProvider, {
  useTopCompanyCommonCorporateContext,
} from '@/creditflowresearch/application/TopCompanies/topCompaniesCommonCorporate/TopCompaniesCommonCorporateContext';
import { CORPORATE_TOP_COMPANIES_CONFIG } from '@/creditflowresearch/ui/components/TopCompanies/constants';

const TopCompaniesCorporate = ({ className }: { className?: string }) => {
  const commonData = useTopCompanyCommonCorporateContext();
  const { activeTab } = commonData;
  const { component: Component, title } = CORPORATE_TOP_COMPANIES_CONFIG[activeTab];

  return (
    <TopCompaniesCommon component={ <Component /> } isCorporate commonData={ commonData } title={ title } className={ className } />
  );
};

export default ({ className }: { className?: string }) => {
  const { topParents } = useParentPageContext();

  return (
    <TopCompanyCommonCorporateContextProvider topParents={ topParents }>
      <CorporateTopIssuersContextProvider topParents={ topParents }>
        <CorporateTopRatingAgencyContextProvider>
          <CorporateTopUnderwritersContextProvider topParents={ topParents }>
            <TopCompaniesCorporate className={ className } />
          </CorporateTopUnderwritersContextProvider>
        </CorporateTopRatingAgencyContextProvider>
      </CorporateTopIssuersContextProvider>
    </TopCompanyCommonCorporateContextProvider>
  );
};
